let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("935xC")).then(() => parcelRequire('jvE81'));